module.exports = __webpack_public_path__ + "img/exit-fullscreen.c0a0b5af.svg";